<script>
  import Officer from "./OfficerComponents.svelte";

  // You can replace the imageUrl with actual URLs to the officers' profile pictures
  let officers = [
    {
      name: "Joshua Zheng",
      position: "President",
      imageUrl: "/assets/officers/1by1.jpg", // Placeholder image
      description:
        "Built and maintains ACM’s website (yes, this one!) while keeping it from combusting. Hid 7 Easter eggs—can you find them all, or will you rage quit? No Ctrl+Shift+I… the dev gods are watching.",
    },
    {
      name: "Pranav Kuppa",
      position: "Vice President",
      imageUrl: "/assets/officers/pranav.jpg", // Placeholder image
      description:
        "Prenav leads outreach for ACM, connecting with professors, guest speakers, and companies to organize talks and workshops.",
    },
    {
      name: "Zephyriah Spaar",
      position: "Vice President",
      imageUrl: "/assets/officers/zj.jpg", // Placeholder image
      description:
        "Zephyriah focuses on creating opportunities for members to grow in the computing field.",
    },
    {
      name: "Arvin Adeli",
      position: "Vice President",
      imageUrl: "/assets/officers/arvin.jpg", // Placeholder image
      description:
        " focused on supporting chapter initiatives, fostering collaboration, and contributing to the success of projects and events.",
    },
    {
      name: "Mihir Talati",
      position: "Officer",
      imageUrl: "/assets/officers/mihir.jpg", // Placeholder image
      description:
        "Mihir Talati, dual-majoring in Physics and CS, is co-president of ACM with interests spanning quantum algorithms, high-energy physics, and research in Quantum Machine Learning and Particle Accelerator design.",
    },
    {
      name: "Sam Sussman",
      position: "Officer",
      imageUrl: "/assets/officers/Screenshot 2024-09-24 021933.png", // Placeholder image
      description:
        "Sam helps manage ACM’s events, bringing new learning opportunities to students.",
    },
    {
      name: "Benjamin Li",
      position: "Outreach Officer",
      imageUrl: "/assets/officers/ben.jfif", // Placeholder image
      description:
        "Ben manages outreach and advertising for the club, expanding its reach and creating unique member opportunities.",
    },
    {
      name: "Matthew M",
      position: "Lead Mentor",
      imageUrl: "/assets/officers/mathew.jpg", // Placeholder image
      description:
        "Mathew leads ACM’s graphics and social media, explores AI and its applications, and will head our mentorship program",
    },
    {
      name: "Nana Metchurtchlishvili",
      position: "Treasurer",
      imageUrl: "/assets/officers/nana.jpg", // Placeholder image
      description:
        "Nana handles ACM’s money so the rest of us don’t accidentally spend it all on pizza. She manages the club’s budget, coordinates funding requests with the CS department, and ensures our finances stay organized and on track.",
    },
    {
      name: "Mario Kalpakis",
      position: "Outreach",
      imageUrl: "/assets/officers/marios.png", // Placeholder image
      description:
        "Marios is focused on building a strong community of CS undergrads.",
    },
    {
      name: "Trevor Kim",
      position: "Web Developer",
      imageUrl: "/assets/officers/trevor.jpg", // Placeholder image
      description:
        "Trevor loves learning about anything CS, physics, or math related.",
    },
    {
      name: "Ishan Kar",
      graduationYear: 2025,
      position: "Officer",
      imageUrl: "/assets/officers/ishan_profile.png",
      description: "Ishan is passionate about technology and leadership, responsible for restarting the ACM chapter at UMD. He is currently a software engineer intern at Amazon.",
    },
    {
      name: "Larry Herman",
      position: "Advisor",
      imageUrl: "/assets/officers/larry.jpg", // Placeholder image
      description:
        "Larry is an instructor and advisor at UMD, guiding students towards excellence in computing.",
    },
  ];
  let eggRevealed = false;

  function handleEasterEggReveal() {
    eggRevealed = true;
  }
</script>

<div class="officers-container">
  {#each officers as officer, index}
    <Officer
      name={officer.name}
      position={officer.position}
      imageUrl={officer.imageUrl}
      description={officer.description}
      gradientType={(Math.floor(index / 3) % 3) + 1}
    />
  {/each}
</div>

<li style="text-align: center; list-style: none;">
  {#if !eggRevealed}
    <button class="easter-egg-button" on:click={handleEasterEggReveal}>
      &gt;_&lt;
    </button>
  {:else}
    <span class="easter-egg-reveal">
      🥚 Rotten Easter egg! keep hunting - JZ!
    </span>
  {/if}
</li>

<style>
  .officers-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 20px;
    background-color: #000;
  }
  .easter-egg-button {
    padding: 0.3rem 0.6rem;
    border: none;
    border-radius: 6px;
    background-color: transparent;
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.8rem;
    font-weight: normal;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: none;
    opacity: 0.3;
  }

  .easter-egg-button:hover {
    color: #ffd520;
    opacity: 0.7;
    transform: scale(1.05);
    background-color: rgba(255, 255, 255, 0.05);
  }

  .easter-egg-reveal {
    font-size: 0.9rem;
    color: #fff;
    background: rgba(255, 255, 255, 0.15);
    padding: 0.5rem;
    border-radius: 6px;
    display: inline-block;
    animation: popIn 0.4s ease;
  }

  @keyframes popIn {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media only screen and (max-width: 600px) {
    :global(body) {
      overflow-x: hidden; /* Prevent horizontal scrolling */
    }
    .officers-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      padding: 1vw;
      background-color: #000;
    }
  }
</style>
